package features.booking
enum class SeatStatus {
    AVAILABLE,
    SELECTED,
    OCCUPIED
}

data class Seat(
    val id: Int,
    val status: SeatStatus = SeatStatus.AVAILABLE
)